import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'shared-background-rectangle',
    templateUrl: './background-rectangle.component.html',
    styleUrls: ['./background-rectangle.component.scss'],
    standalone: false
})
export class BackgroundRectangleComponent implements OnInit {

  @Input() height: string;

  constructor() { }

  ngOnInit(): void {
  }

}
